module.exports = __webpack_public_path__ + "img/startup-italia.69da9887.png";